import { http } from "services/http";

import type {
  PromocodeCodeListResponse,
  PromocodeIdRequest,
  PromocodesListResponse,
  PromocodeShowResponse,
  PromocodesPageRequest,
  PromocodeStoreRequest,
  PromocodeStoreResponse,
  PromocodeUpdateRequest,
  Promocode,
} from "models/promocodes.model";

export const promocodesApi = {
  getData: (data?: PromocodesPageRequest) =>
    http.quiet().post<PromocodesListResponse>("/api/promocodes", data ? { ...data } : null),
  showPromocodeType: (data: PromocodeIdRequest) =>
    http.quiet().post<PromocodeShowResponse>("/api/promocodes/show", { ...data }),
  createPromocodeType: (data: PromocodeStoreRequest) =>
    http.quiet().post<PromocodeStoreResponse>("/api/promocodes/store", { ...data }),
  updatePromocode: (data: PromocodeUpdateRequest) =>
    http.quiet().post<Promocode>("/api/promocodes/update", { ...data }),
  destroyPromocode: (data: PromocodeIdRequest) =>
    http.quiet().post("/api/promocodes/destroy", { ...data }),
  getCodeList: (data?: PromocodesPageRequest) =>
    http.quiet().post<PromocodeCodeListResponse>("/api/promocodes/code-list", data ? { ...data } : null),
};
